import $ from 'jquery';
import 'foundation-sites/js/foundation';

$('[data-drilldown]').each((i, element) => {
    const $el = $(element);

    setTimeout(()=>{
        $el.find('li.current-menu-item > a, li.current-menu-ancestor > a').click();
    }, 0);
});